
<!--====== Banar Start ======-->

<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center  w-100">

                <!-- "> md" -->
                <img src="../../../assets/images/banners/Database-Banner.png"
                    class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="" />

                <!-- "<= md" -->
                <img src="../../../assets/images/banners/database-mobile.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="" />

                <!-- <img src="../../../assets/images/banners/mitbannername.png"
                    alt="Banner-mit" class="img-responsive w-100 h-100"> -->
                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-8 col-md-4 col-sm-6 banner-section">
                            <div class="align-items-center banner-content-title  global_title global_banner_title">
                                <span>Database Services</span>
                            </div>
                            <div class="global_sub_title global_banner_subtitle mt-3">
                                <span>Start building with fully-managed cloud databases from Maganti IT.</span>
                            </div>
                            <div class="col pt-lg-5 pt-3 mt-lg-3">
                                <!-- <a href="contact" class="global_button  text-left col pt-5 text-white white_button">
                                    TALk TO AN EXPERT
                                    <i class="fas fa-arrow-right position-relative mt-1 ml-4 display-6"
                                        style="font-weight: 500"></i>
                                </a> -->

                                <a href="contact" class="global_button  text-left col  text-white white_button">
                                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png" alt="" /></div>
                                    EXPLORE
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class=" banner-subsection col">
         <h5>Trusted by Global Technology companies</h5>
         </div> -->
    </div>
</div>

<!--====== Banar End ======-->


<!--====== Build applications Start ======-->
        <div class="feature-large-images-wrapper section-space--ptb_100">
            <div class="container">
                <div class="cybersecurity-about-box">
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="conact-us-wrap-one managed-it">
                                <div class="heading  text-black">
                                    Build applications that scale with the pace of your business with managed and
                                    intelligent Database in the cloud.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-7 offset-lg-1">
                            <div class="cybersecurity-about-text">
                                <div class="text global_section_content">Oracle is a database whose main purpose is to
                                    store and retrieve information. This database is built for enterprises
                                    looking for higher performance computing with easy migration of their local
                                    applications to cloud. Oracle also helps business to automate their
                                    infrastructure which helps accelerate innovation. This is the most cost-effective
                                    way to manage information and applications.</div>
                                    
                                    <div class="text global_section_content">
                                    It is a multi-model
                                    database management system commonly used for running online transaction processing,
                                    data warehousing and mixed database workloads. Oracle has features
                                    such as sharing, private cloud, high-speed performance, high-speed data
                                    distribution, security permission management and others that enable hybrid
                                    deployments. We revamp your business by integrating with oracle to do the following
                                    functions.</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
<!--====== Build applications End ======-->


<!--====== Database Managed Services Start ======-->

        <div class="feature-icon-wrapper section-space-1--ptb_100">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="section-title-wrap text-center section-space--mb_40">
                            <div class="section-sub-title mb-20 global_section_header sixthheading">Database Managed Services</div>
                            <p class="software-text global_section_content">Get preventive maintenance and on-demand support for all your
                                applications with our software maintenance and support solutions.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="feature-list__two">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 wow move-up">
                                    <div class="ht-box-icon style-02 single-svg-icon-box">
                                        <div class="icon-box-wrap">
                                            <div class="icon">
                                            <img src="../../../assets/images/operation-images/server.png"
                                                    alt="" />
                                              
                                            </div>
                                            <div class="content">
                                                <div class="software-heading  text-black fifthheading">Databases for MongoDB
                                                </div>
                                                <div class="software-text mt-3 global_section_content">
                                                Maganit IT Cloud Databases for MongoDB provides a JSON document store that can be scaled vertically and horizontally.
                                                 It has a rich query and aggregation framework and is accessible through a wide range of application 
                                                 frameworks and languages.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 wow move-up">
                                    <div class="ht-box-icon style-02 single-svg-icon-box">
                                        <div class="icon-box-wrap">
                                            <div class="icon">
                                                <img src="../../../assets/images/operation-images/administration.png"
                                                    alt="" />
                                            </div>
                                            <div class="content">
                                                <div class="software-heading  text-black fifthheading">Databases for Elasticsearch</div>
                                                <div class="software-text mt-3 global_section_content"> Maganti IT Cloud Databases for Elasticsearch combines the flexibility of
                                                     a full-text search engine with the power of a JSON document database’s indexing.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 wow move-up">
                                    <div class="ht-box-icon style-02 single-svg-icon-box">
                                        <div class="icon-box-wrap">
                                            <div class="icon">
                                                <img src="../../../assets/images/operation-images/trouble-shooting.png"
                                                    alt="" />
                                            </div>
                                            <div class="content">
                                                <div class="software-heading  text-black fifthheading">Databases for PostgreSQL</div>
                                                <div class="software-text mt-3 global_section_content">Maganti IT Cloud Databases for PostgreSQL offers an object-relational SQL database, complemented by
                                                     powerful enhancements like indexable JSON, publish and subscribe functions and drivers.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 wow move-up">
                                    <div class="ht-box-icon style-02 single-svg-icon-box">
                                        <div class="icon-box-wrap">
                                            <div class="icon">
                                                <img src="../../../assets/images/operation-images/configuration.png"
                                                    alt="" />
                                            </div>
                                            <div class="content">
                                                <div class="software-heading text-black fifthheading">Maganti IT Compose for MySQL</div>
                                                <div class="software-text mt-3 global_section_content">Maganti IT Compose for ScyllaDB is a lightning-fast, low-latency NoSQL column store that 
                                                    works as a drop-in replacement for Apache Cassandra. </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 wow move-up">
                                    <div class="ht-box-icon style-02 single-svg-icon-box">
                                        <div class="icon-box-wrap">
                                            <div class="icon">
                                                <img src="../../../assets/images/operation-images/server.png"
                                                    alt="" />
                                            </div>
                                            <div class="content">
                                                <div class="software-heading  text-black fifthheading">Maganti IT Compose for ScyllaDB</div>
                                                <div class="software-text mt-3 global_section_content">Maganti IT Compose for ScyllaDB is a lightning-fast, low-latency NoSQL
                                                     column store that works as a drop-in replacement for Apache Cassandra.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 wow move-up">
                                    <div class="ht-box-icon style-02 single-svg-icon-box">
                                        <div class="icon-box-wrap">
                                            <div class="icon">
                                                <img src="../../../assets/images/operation-images/remote.png"
                                                    alt="" />
                                            </div>
                                            <div class="content">
                                                <div class="software-heading  text-black fifthheading">Hyper Protect DBaaS for MongoDB</div>
                                                <div class="software-text mt-3 global_section_content">Hyper Protect DBaaS for MongoDB provides capabilities to provision, manage, maintain and monitor MongoDB 
                                                    through standardized APIs helping you retain your data in a fully encrypted client database without the need for specialized skills.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 wow move-up">
                                    <div class="ht-box-icon style-02 single-svg-icon-box">
                                        <div class="icon-box-wrap">
                                            <div class="icon">
                                                <img src="../../../assets/images/operation-images/remote.png"
                                                    alt="" />
                                            </div>
                                            <div class="content">
                                                <div class="software-heading  text-black fifthheading">Hyper Protect DBaaS for PostgreSQL</div>
                                                <div class="software-text mt-3 global_section_content">Hyper Protect DBaaS for PostgreSQL provides capabilities to provision, manage, 
                                                    maintain and monitor PostgreSQL through 
                                                    standardized APIs providing advantages such as pervasive encryption, scalability and performance.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 wow move-up">
                                    <div class="ht-box-icon style-02 single-svg-icon-box">
                                        <div class="icon-box-wrap">
                                            <div class="icon">
                                            
                                                    <img src="../../../assets/images/operation-images/maintainence.png"
                                                    alt="operation" />
                                            </div>
                                            <div class="content">
                                                <div class="software-heading  text-black fifthheading">High availability and security</div>
                                                <div class="software-text mt-3 global_section_content">Support multi-region, multi-primary replication, and provide full data oversight with multiple levels of security,
                                                     including network isolation and end-to-end encryption.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
<!--====== Database Managed Services End ======-->

<!--====== Database Managed Services End ======--> 


        <div class=" mobile-border horizantal"></div>
        <div id="androidappdev" class="container-fluid p-5 database_mediacontent">
            <div class="row">
                <div class="col-sm-12 col-md-12">
                    <div class="mobile_android_content global_section_header pt-5">
                        Automation of data migration
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <div class="col-md-12 col-sm-12">

                        <div class="col-md-11 col-sm-11">

                            <div class="mobile_androidsub-content global_section_content">
                                <p class="pt-5">Oracle database migrations are highly automated and reduce the overall
                                    migration effort. The cost
                                    and time required to migrate non-Oracle databases to Oracle platform is much lower.
                                    Oracle provides high performance
                                    export and import utilities. You can automatically provision high availability
                                    configurations to elevate service
                                    levels for maintenance or unexpected failure scenarios. Provisioning choices include
                                    pre-packaged bundles of Oracle Database
                                    options for DevOps, Performance, Security, Analytics and Monitoring.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="mobile_android-image pt-5">
                        <img class="img img-responsive"
                            src="../../../assets/images/database/automated-dataimage.png"
                            alt="" />
                    </div>
                </div>
            </div>
        </div>

<!--====== Database Managed Services Start ======-->  <style>
    @media (min-width: 2560px) {
  .mobile_ios_images img {
    float: right;
  }
}
</style>



<!--====== Database management Start ======--> 


        <div class=" mobile-border horizantal"></div>
        <div class="container-fluid" id="iosappdev">
            <div class="row">
                <div class="col-sm-12 col-md-12">
                    <div class="mobile_android_content global_section_header">
                        Database management
                    </div>
                </div>
            </div>
            <div class="mt-3 ">
                <div class="row">
                    <div class="col-md-6 col-sm-12 text-end text-4k-end">
                        <div class="mobile_ios_images pt-5">
                            <img class="img img-responsive"
                                src="../../../assets/images/database/database-manageimage.png"
                                alt="" />
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="col-md-12 col-sm-12">
                            <div class="col-md-11 col-sm-11">
                                <div class="mobile_ios-subcontent global_section_content">
                                    <p class="mt-5">Oracle Database fits perfectly with businesses and corporations with
                                        portability, isolation, consistency and durability.
                                        It has capability to handle large amount of data without any single failure
                                        providing complete and reliable database system. Oracle
                                        has a protocol to manage multiple databases with same transactions and has most
                                        user-friendly and easy to use features which are usable
                                        on any platform. No matter how big is the database, Oracle provides the best
                                        speed to access the data with highest level of performance.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

<!--====== Database management End ======-->   


<!--======   Backup and Synchronization Start ======--> 
        <div class=" mobile-border horizantal"></div>
        <div class="container-fluid">
            <div class=" p-5 database_mediacontent">

                <div class="row">
                    <div class="col-sm-12 col-md-12">
                        <div class="mobile_android_content global_section_header">
                            Backup and Synchronization
                        </div>
                    </div>
                </div>
                <div class="row" id="arappdev">
                    <div class="col-md-6 col-sm-12">
                        <div class="col-md-12 col-sm-12">

                            <div class="col-md-11 col-sm-11">

                                <div class="mobile_websub-content global_section_content">
                                    <p class="pt-3">Oracle offers quickest online backup and recovery features. It
                                        supports continuous synchronization and recovery
                                        from predefined server storage and you can also set point-in-time recovery.
                                        Oracle ensures the top-level reliability
                                        of your system. As well as, delivers high integrity of data storage. Also,
                                        includes locking and transaction controls
                                        ensuring high level security to database.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="mobile_web-image pt-5">

                            <img class="img img-responsive"
                                src="../../../assets/images/database/data-backupimage.png"
                                alt="backupimage" />

                        </div>
                    </div>
                </div>
            </div>
        </div>

<!--====== Backup and Synchronization End ======-->        



<!--======= Insights section Start =======-->
<!--======= Insights section Start =======-->
<!-- <div class="layouts-section-wrap">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 offset-sm-2 col-sm-8">
                <div class="pt-md-5" data-aos="fade-up">
                    <div class="insight-title global_section_header">
                        Insights
                     
                    </div>
                    <div class="insight-subtitle global_sub_title vision-content-section mt-3">
                        <span>
                            Explore insights and inspiration to unlock innovation, build trust, and engineer advantage
                            for your digital journey.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">

        <div class="-row d-lg-none pt-lg-4">
            <div class="px-4 -col-lg-12">
                <div class="flexible-image-slider-wrap">
                    <swiper-container class="single-flexible__container" slides-per-view="1" autoplay="true" loop="true" navigation="true" pagination="true">
                      

                           <swiper-slide>
                               
                                <div class="single-flexible-slider">
                                    <img src="../../../assets/images/homepage/insights/slider1.png"
                                        class="img img-responsive w-100 h-100" alt="firstslider" />
                                    <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                                        <div class="insight-content global_section_header  px-0">
                                            <span>The Future of Marketing Personalization: AI-Powered Journeys</span>
                                        </div>
                                        <div class="insight-subcontent global_section_content px-0 pt-lg-1">
                                            <div>Across the entire customer journey, AI is assisting marketers in
                                                providing more helpful,
                                                enjoyable experiences for shoppers and improving performance: from
                                                one-to-one messaging that doesn't sound like spam,
                                                to dynamic website design that adapts to individual users. Find how
                                                retail stores can capitalize on this technology trend. </div>
                                        </div>
                                        <div class="insight-button text-center py-3 py-md-5">
                                            <a href="personalize-and-machine-learning" class="global_button">
                                                <div class="dub-arrow"><img
                                                        src="../../../assets/images/button/arrowBlack.png"
                                                        alt="insight arrow" /></div>READ ALL INSIGHTS
                                            </a>
                                        </div>
                                     
                                    </div>
                                </div>
                              
                            </swiper-slide>
                            <swiper-slide>

                                
                                <div class="single-flexible-slider">
                                    <img src="../../../assets/images/homepage/insights/slider2.png"
                                        class="img img-responsive w-100 h-100" alt="secondslider" />
                                    <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                                        <div class="insight-content global_section_header px-0">
                                            <span>Embracing the next era of Digital: From Survival, Thriving to
                                                Reinvigorating </span>
                                        </div>
                                        <div class="insight-subcontent global_section_content px-0 pt-lg-5">
                                            <div>Digital has become the default. The question now no longer remains
                                                whether digital is an avenue for business,
                                                but about how it’s put into use.
                                                Learn How far businesses have progressed into the digital post-pandemic
                                                and how far they can go to adapt to the changing customer mindset.
                                            </div>
                                        </div>
                                        <div class="insight-button text-center py-3 py-md-5">
                                            <a href="insights/blogs/postpandamic" class="global_button">
                                                <div class="dub-arrow"><img
                                                        src="../../../assets/images/button/arrowBlack.png"
                                                        alt="casestudy button" /></div>READ ALL INSIGHTS
                                            </a>
                                        </div>
                                    </div>
                                </div>
                  
                            </swiper-slide>

                            <swiper-slide>

                     
                                <div class="single-flexible-slider">
                                    <img src="../../../assets/images/homepage/insights/slider3.png"
                                        class="img img-responsive w-100 h-100" alt="thirdslider" />
                                    <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                                        <div class="insight-content global_section_header px-0">
                                            <span>Drive digital adoption.Every minute. Every hour.Every day</span>
                                        </div>
                                        <div class="insight-subcontent global_section_content ypx-0 pt-lg-5">
                                            <div>Increase Software adoption and Knowledge retention while simultaneously
                                                making a positive impact on the working lives of your employees--now and
                                                in
                                                the future.Maganti IT delivers a of any enterprise or custom software,
                                                desktop and web - based application.Find out how our customisable
                                                digital
                                                adoption platform can improve your business processes. </div>
                                        </div>

                                        <div class="insight-button text-center py-3 py-md-5">
                                            <a href="migrate-cloud" class="global_button">
                                                <div class="dub-arrow"><img
                                                        src="../../../assets/images/button/arrowBlack.png"
                                                        alt="arrow button" /></div>READ ALL INSIGHTS
                                            </a>
                                        </div>
                                    </div>
                                </div>
                   
                                
                            </swiper-slide>
                           

                       
                
                        <div class="swiper-nav-button insight-scroll bg-dark swiper-button-next">
                            <i
                                class="fal fa-chevron-right text-white display-1"></i>
                                <i class="fa-regular fa-chevron-right"></i>
                              
                        </div>
                        <div class="swiper-nav-button insight-scroll bg-dark swiper-button-prev"> <i
                                class="fal fa-chevron-left text-white display-1"></i>
                        </div>
                    </swiper-container>
                </div>
            </div>
        </div>
        <div class="" >
            
            <app-insightsslider></app-insightsslider>
          </div>
    </div>
</div> -->

<div class="" >
    <app-insightsslider></app-insightsslider>
  </div>
<!--======= Insights section Ends =======-->
<!--======= Insights section Ends =======-->
<style>
    
</style>